const getGender = (gender: string): number => {
	if (gender === 'male') return 1
	else if (gender === 'female') return 2
	return 0
}

export default getGender
